export default __webpack_public_path__ + "static/media/navimage.3f918f8a.png";